import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/footer/main";
import Sharebtn from "../../../components/Sharebtn/share";
import "./BlogRead.css";
import Axios from "axios";
// import TopicList from "../../../components/topiclist/topiclist";
import { apiURL } from "../../../keys.js";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";

const HeaderBlogCard = (props) => {
  return (
    <div>
      <div className="blogread_image_div">
        <img className="blogread_img_div" src={props.blog.image} width="100%" />
        {/* <img
          src="https://img.etimg.com/thumb/width-640,height-480,imgsize-43442,resizemode-1,msid-68147761/small-biz/policy-trends/gst-2-0-preparing-for-integration-of-e-way-bills-with-gst-returns/gettyimages-954155950.jpg"
                  width="90%"                  
        /> */}
      </div>
      <div style={{ position: "relative" }}>
        <div className="mainhead_blogread_user_image">
          <div className="row">
            <div className="col-4">
              <img
                src="https://avatars3.githubusercontent.com/u/31445077?s=460&u=59bc6f20786c76032b87bab0abad5e341c4d5489&v=4"
                width="100%"
              />
            </div>
            <div className="col-8 pl_0">
              <p className="mb_0">
                <span className="tgrey fs14">Written By </span>
                <br />
                <b>Rupansh Kapoor</b>
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex">
          {props.blog.category.map((cats) => {
            return (
              <a style={{ textDecoration: "none" }} href={`/category/${cats}`}>
                {" "}
                <p className=" tblue ml_2px mb_0 fbold blog_topic_read alink">
                  {cats.toUpperCase()}
                </p>
              </a>
            );
          })}
        </div>

        {/* <p className="blog_topic tblue mb_0 fbold fs12" style={{ marginTop: "4px" }}>
          GST
        </p> */}
        <h1 className="heading_blog">{props.blog.title}</h1>
        <p className="tgrey date_text">
          <i className="fas fa-clock"></i> 23rd May, 2020{" "}
          <b className="tblue">
            <i class="fas fa-eye"></i> {props.blog.readBy} views
          </b>
        </p>
      </div>
    </div>
  );
};
const TopicsBtn = (props) => {
  return (
    <a style={{ textDecoration: "none", color: "black" }} href={`/category/${props.topic}`}>
      <div className="topic_btn">
        <p>{props.topic}</p>
      </div>
    </a>
  );
};
const TopicList = () => {
  return (
    <div className="m_auto mb_4rem mt_4rem">
      <p className="tgrey fs20px">
        <i class="fas fa-search"></i> Search topics
      </p>
      <div className="d-flex topic_scroll_x">
        <TopicsBtn topic="GST" />
        <TopicsBtn topic="TAX" />
        <TopicsBtn topic="FINANCE" />
        <TopicsBtn topic="ACCOUNTS" />
        <TopicsBtn topic="STARTUP" />
      </div>
    </div>
  );
};

const ListBtn = (props) => {
  return (
    <a style={{ textDecoration: "none" }} href={`/blog/${props.blog.slug}`}>
      <div style={{ marginLeft: "20px" }} className="listbox">
        <div>
          <img
            width="300px"
            src={props.blog.image}
            // src="https://img.etimg.com/thumb/width-640,height-480,imgsize-43442,resizemode-1,msid-68147761/small-biz/policy-trends/gst-2-0-preparing-for-integration-of-e-way-bills-with-gst-returns/gettyimages-954155950.jpg"
          />
        </div>
        <div style={{ paddingLeft: "6px" }}>
          <p className="fs12 fbold mb_0 tblack rec_card_title" style={{ paddingTop: "15px" }}>
            {props.blog.title}
          </p>
          {/* <p className="mb_0 tgrey">{props.blog.subContent}</p> */}
          <p className="mb_10px tgrey">
            <i class="fas fa-clock"></i> {props.blog.readTime} read time
          </p>
        </div>
      </div>
    </a>
  );
};
const RecommendedList = (props) => {
  return (
    <div className="m_auto mb_4rem mt_4rem">
      <p className="tgrey fs20px">
        Recommended <i class="fas fa-arrow-right"></i>
      </p>
      <div className="d-flex topic_scroll_x">
        {props.blogs.map((blog, id) => (
          <ListBtn key={id} blog={blog} />
        ))}
        {/* <ListBtn topic="1" /> */}
        {/* <ListBtn topic="1" /> */}
        {/* <ListBtn topic="1" /> */}
        {/* <ListBtn topic="1" /> */}
        {/* <ListBtn topic="1" /> */}
      </div>
    </div>
  );
};

const BlogRead = (props) => {
  const [blog, setBlog] = useState([]);
  const [trends, setTrends] = useState([]);
  const [trendloading, setTrendloading] = useState(true);
  const [loading, setLoading] = useState(true);

  const Updatecount = (id) => {
    Axios.post(`${apiURL}/blogs/updatecount/${id}`)
      .then((data) => {
        // console.log("updated count");
      })
      .catch((error) => {
        setLoading(false);
        // console.log(error);
      });
  };

  useEffect(() => {
    Axios.get(`${apiURL}/blogs/slugview/${props.match.params.slug}`)
      .then((data) => {
        setBlog(data.data.data[0]);
        setLoading(false);
        Updatecount(data.data.data[0]._id);
        console.log(data.data.data[0]);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });

    Axios.get(`${apiURL}/blogs/trends`).then((data) => {
      setTrends(data.data.data);
      setTrendloading(false);
    });
  }, []);

  return (
    <div>
      <Navbar />
      <div className="container">
        <Link to="/">
          <button type="button" class="btn btn-light mt_7rem mb_10px">
            Go Back
          </button>
        </Link>
        {loading ? (
          <>
            <br />
            <div class="spinner-border mt_7rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </>
        ) : (
          <HeaderBlogCard blog={blog} />
        )}
        {/* {props.match.params.slug} */}
        <div className="paras_text">
          {/* {renderHt} */}
          {loading ? (
            <>
              <br />
              <div class="spinner-border mt_7rem" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </>
          ) : (
            renderHTML(blog.content)
          )}
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-6">
            <p className="comment_btn">VIEW COMMENTS</p>
          </div>
          <div className="col-6 ">
            <p className="fr pr_20 next_btn pder">View Next </p>
          </div>
        </div>
        <hr />
        <TopicList />
        <hr />
        {trendloading ? (
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        ) : (
          <RecommendedList blogs={trends} />
        )}
        <hr />
        <p className="tgrey fs20px ">COMMENTS</p>
      </div>

      <Footer />
      <Sharebtn />
    </div>
  );
};
export default BlogRead;
